import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';

// The Cambridgeshire Ceremonies brand has no logo image — the masthead is a
// "Cambridgeshire Ceremonies" text wordmark (Cormorant Garamond Light) on a white
// band. gb-ui-header requires an img brand, so this component renders the same
// bootstrap navbar structure itself with a wordmark link instead.
@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, RouterModule],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(
			'https://chapter.registrars.staging.bookinglab.co.uk/cambridgeshire-staging/37002',
			'_blank'
		);
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}

	navigation: NavLink[] = [
		// {
		// 	text: 'Home',
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/',
		// },
		// {
		// 	text: 'Marriage and Civil Partnership',
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/marriage-and-cp',
		// },
		// {
		// 	text: 'Fees',
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/fees',
		// },
		// {
		// 	text: 'Log In',
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/log-in',
		// },
		// {
		// 	text: "What's On",
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/whatson',
		// },
		// {
		// 	text: 'Contact Us',
		// 	url: 'https://www.cambridgeshireceremonies.co.uk/contact-us',
		// },
	];
}
